import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faFilePdf, faTrash } from '@fortawesome/free-solid-svg-icons'

library.add(faFilePdf)
library.add(faTrash)

dom.watch()
